export const UPLOAD_PDFS = 'upload_pdfs';
export const TOGGLE_IMITATION = 'toggle_imitation';
export const SELECT_TEMPLATES = 'select_template';
export const UPDATE_TEXT = 'update_text';


// WEBPACK FOOTER //
// ./src/actions/types.js